import { TFuncKey } from "i18next";
import { FC } from "react";

import { Section } from "@/components/Onboarding/Onboarding.constants";

import { WizardStep } from "./WizardStep/WizardStep";

export interface StepsProps {
  sections: Section[];
  currentStep: number;
  currentSubStep: string | undefined;
  property?: PropertyKey;
  missingInfo?: boolean;
}

export const Steps: FC<StepsProps> = ({
  sections,
  missingInfo,
  ...restProps
}) => (
  <>
    {sections.map((section, index) => (
      <WizardStep
        key={section.title}
        {...restProps}
        {...section}
        missingInfo={index === 1 && missingInfo}
        title={section.title as TFuncKey}
        step={index + 1}
        last={index === sections.length - 1}
      />
    ))}
  </>
);
